const ArrowSwitch = ({ color, type }) => {
  const regular = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.08211 2.29289C7.47263 2.68342 7.47263 3.31658 7.08211 3.70711L5.41421 5.375H21C21.5523 5.375 22 5.82272 22 6.375C22 6.92728 21.5523 7.375 21 7.375H5.41421L7.08211 9.04289C7.47263 9.43342 7.47263 10.0666 7.08211 10.4571C6.69158 10.8476 6.05842 10.8476 5.66789 10.4571L2.29289 7.08211C1.90237 6.69158 1.90237 6.05842 2.29289 5.66789L5.66789 2.29289C6.05842 1.90237 6.69158 1.90237 7.08211 2.29289ZM16.9179 13.5429C17.3084 13.1524 17.9416 13.1524 18.3321 13.5429L21.7071 16.9179C22.0976 17.3084 22.0976 17.9416 21.7071 18.3321L18.3321 21.7071C17.9416 22.0976 17.3084 22.0976 16.9179 21.7071C16.5274 21.3166 16.5274 20.6834 16.9179 20.2929L18.5858 18.625H3C2.44772 18.625 2 18.1773 2 17.625C2 17.0727 2.44772 16.625 3 16.625H18.5858L16.9179 14.9571C16.5274 14.5666 16.5274 13.9334 16.9179 13.5429Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default ArrowSwitch;
